export function getHomePaths(workspaceId?: string) {
    const workspaceSegment = workspaceId ?? ":workspaceId";
    const entry = "/home";

    const root = `${entry}/${workspaceSegment}`;

    return {
        entry,
        root,
        createClientWorkspace: `${root}/partner/create-workspace`,
        zeroState: `/app/${workspaceSegment}/home/get-started`,
        restrictedState: `/app/${workspaceSegment}/home/restricted`
    };
}
